export const Settings_Description3Length = "Rewind365.Modules.Zdi.Description3Length";